export default __webpack_public_path__ + "static/media/891.d0b90260.gif";